import React, { useEffect } from 'react';
import { BaseLayerView } from '@/framework';
import { base64Kit } from '@/utils/base64-kit';
import { convertImageToWebp } from '@/utils/file-kit';
import { IBaseLayerViewProps, IImageLayerProps, IRenderLayerProps } from '@/version-types';
import { getImageEffectResultImgSize } from '../constants/image-layer-constant';
import ImageEffectAction from '../utils/image-effect-action';

const ImageEffectLayer: React.FC<
    Pick<IRenderLayerProps, 'layer' | 'isNavigator'> & Pick<IBaseLayerViewProps, 'layerContentChildrenWrapStyle'>
> = ({ layer, isNavigator, layerContentChildrenWrapStyle }) => {
    const { id, data, width, height } = layer;
    const { effect } = data as IImageLayerProps;
    const __renderGLCanvas = layer.__renderGLCanvas;
    const __isCropImage = layer.__isCropImage;
    const __isDeformationImage = layer.__isDeformationImage;
    const imgEffectResultImgSize = getImageEffectResultImgSize(data as IImageLayerProps);
    useEffect(() => {
        if (!isNavigator) {
            if (__renderGLCanvas) {
                ImageEffectAction.displayView(layer);
                return;
            }
        }
    }, [__renderGLCanvas]);

    const effectUrl = effect?.screenshotUrl || '';
    const screenshotLocalUrl = effectUrl ? convertImageToWebp(base64Kit.getLocalUrl(effectUrl)) : effectUrl;

    // 舞台gl渲染
    if (!isNavigator && __renderGLCanvas) {
        return (
            <>
                <BaseLayerView
                    layer={{ ...layer, id: `${layer.id}_effect` }}
                    isNavigator={isNavigator}
                    layerContentChildrenWrapStyle={layerContentChildrenWrapStyle}
                >
                    <div
                        id={`${id}GLContainer`}
                        style={{
                            width: width * imgEffectResultImgSize,
                            height: height * imgEffectResultImgSize,
                            opacity: layer.opacity,
                            transform: `translate(-${
                                (width * imgEffectResultImgSize - width) / 2
                            }px, -${(height * imgEffectResultImgSize - height) / 2}px)`,
                            transformOrigin: 'center center',
                        }}
                        className="image-effect-gl-container"
                    ></div>
                </BaseLayerView>
            </>
        );
    }

    if (layer.__isBasicOperating || !screenshotLocalUrl) {
        return null;
    }

    const imageStyle = effect?.effectPosition
        ? {
              width: effect.effectPosition.right - effect.effectPosition.left,
              height: effect.effectPosition.bottom - effect.effectPosition.top,
              transform: `translate(${effect.effectPosition.left}px, ${effect.effectPosition.top}px)`,
              transformOrigin: '0 0',
          }
        : {
              width: width * imgEffectResultImgSize,
              height: height * imgEffectResultImgSize,
          };
    const containerStyle = effect?.effectPosition
        ? {}
        : { display: 'flex', justifyContent: 'center', alignItems: 'center' };

    return (
        <BaseLayerView
            layer={{ ...layer, id: `${layer.id}_effect` }}
            isNavigator={isNavigator}
            disableEvents={true}
            layerContentChildrenWrapStyle={{
                ...layerContentChildrenWrapStyle,
                ...containerStyle,
            }}
        >
            <img
                src={screenshotLocalUrl}
                style={{
                    ...imageStyle,
                    opacity: __isCropImage || __isDeformationImage ? 0 : layer.opacity,
                }}
            />
        </BaseLayerView>
    );
};

export default React.memo(ImageEffectLayer);
